import React, { useState } from "react";
import { toast } from "react-toastify";

import PopoverPopupState from "./../Esnad/Details";

import styles from "./../../styles/azkar.module.css";
import { useNavigate } from "react-router-dom";

const evningAzkar = {
  hold: {
    text: `بسمِ اللهِ الذي لا يَضرُ مع اسمِه شيءٌ في الأرضِ ولا في السماءِ وهو السميعُ العليمِ`,
    count: 3,
    Details: `عن أبو داود واللفظ له، والترمذي وقال حسن صحيح غريب، والنسائي عن عبد الله بن خبيب رضي الله عنه قال: قال رسول الله صلى الله عليه وسلم: قل، قلت يا رسول الله ما أقول؟ قال: قل هو الله أحد، والمعوذتين حين تمسي وحين تصبح ثلاث مرات تكفيك من كل شيء`,
  },
  Falaq: {
    text: `رَضِيتُ بِاللهِ رَبًّا، وَبِالْإِسْلَامِ دِينًا، وَبِمُحَمَّدٍ صَلَّى اللهُ عَلَيْهِ وَسَلَّمَ نَبِيًّا، إِلَّا كَانَ حَقًّا عَلَى اللهِ أَنْ يُرْضِيَهُ يَوْمَ الْقِيَامَةِ`,
    count: 1,
    Details: `ورد هذا الأمر في ” سنن الترمذي ” حديث رقم: (3924) – حَدَّثَنَا عَبْدُ بْنُ حُمَيْدٍ ، قَالَ : حَدَّثَنَا مُحَمَّدُ بْنُ إِسْمَاعِيلَ بْنِ أَبِي فُدَيْكٍ ، قَالَ : حَدَّثَنَا ابْنُ أَبِي ذِئْبٍ ، عَنْ أَبِي سَعِيدٍ البَرَّادِ ، عَنْ مُعَاذِ بْنِ عَبْدِ اللهِ بْنِ خُبَيْبٍ ، عَنْ أَبِيهِ ، قَالَ : خَرَجْنَا فِي لَيْلَةٍ مَطِيرَةٍ وَظُلْمَةٍ شَدِيدَةٍ نَطْلُبُ رَسُولَ اللهِ صَلَّى اللَّهُ عَلَيْهِ وَسَلَّمَ يُصَلِّي لَنَا ، قَالَ : فَأَدْرَكْتُهُ ، فَقَالَ : قُلْ فَلَمْ أَقُلْ شَيْئًا ، ثُمَّ قَالَ : قُلْ ، فَلَمْ أَقُلْ شَيْئًا ، قَالَ : قُلْ ، فَقُلْتُ ، مَا أَقُولُ ؟ قَالَ : قُلْ : قُلْ هُوَ اللَّهُ أَحَدٌ ، وَالمُعَوِّذَتَيْنِ حِينَ تُمْسِي وَتُصْبِحُ ثَلاَثَ مَرَّاتٍ تَكْفِيكَ مِنْ كُلِّ شَيْءٍ.`,
  },
  people: {
    text: `اللَّهمَّ بِكَ أمسَينا وبِكَ أصبَحنا وبِكَ نحيا وبِكَ نموتُ وإليكَ المصير
 `,
    count: 1,
    Details: `فعن عبد الله بن خبيب -رضي الله عنه- عن النبيّ -صلّى الله عليه وسلّم- قال: (خرجنا في ليلةِ مَطَرٍ وظُلْمَةٍ شديدةٍ نطلبُ رسولَ اللهِ صلى الله عليه وسلم لِيُصليَ لنا، فأدركناه، فقال: أصليتم؟ فلم أقلْ شيئًا، فقال: قلْ. فلم أقلْ شيئًا، ثم قال: قلْ. فلم أقلْ شيئًا، ثم قال: قلْ: فقلتُ: يا رسولَ اللهِ، ما أقولُ؟ قال: قل هو الله أحد والمُعَوِّذَتين حينَ تُمسي وحينَ تُصبحُ ثلاثَ مراتٍ تُكفيك مِن كلِّ شيءٍ)`,
  },
  // this is 2
  become: {
    text: `سبحانَ اللَّهِ وبحمدِهِ`,
    count: 100,
    Details: `جاء من حديث أبي هريرة  قال: كان رسولُ الله ﷺ يُعلِّم أصحابَه يقول: إذا أصبح أحدُكم فليقل: اللهم بك أصبحنا، وبك أمسينا، وبك نحيا، وبك نموت، وإليك المصير،  نموت، وإليك النُّشور`,
  },
  unseen: {
    text: `(سُبْحَانَ اللهِ وَبِحَمْدِهِ، عَدَدَ خَلْقِهِ وَرِضَا نَفْسِهِ وَزِنَةَ عَرْشِهِ وَمِدَادَ كَلِمَاتِهِ)`,
    count: 3,
    Details: `جاء عن أبي هريرة  قال: قال أبو بكر : يا رسول الله، مُرني بشيءٍ أقوله إذا أصبحتُ، وإذا أمسيتُ. قال: قل: اللهم عالم الغيب والشَّهادة، فاطر السَّماوات والأرض، ربَّ كل شيءٍ ومليكه، أشهد أن لا إله إلا أنت، أعوذ بك من شرِّ نفسي، ومن شرِّ الشيطانِ وشِرْكِه، قال: قُلْه إذا أصبحتَ، وإذا أمسيتَ، وإذا أخذتَ مضجعك`,
  },
  Glory: {
    text: `(اللَّهُمَّ إنِّي أمسيت أُشهِدُك، وأُشهِدُ حَمَلةَ عَرشِكَ، ومَلائِكَتَك، وجميعَ خَلقِكَ: أنَّكَ أنتَ اللهُ لا إلهَ إلَّا أنتَ، وأنَّ مُحمَّدًا عبدُكَ ورسولُكَ)`,
    count: 1,
    Details: `روى مسلم (2726) عَنِ ابْنِ عَبَّاسٍ عَنْ جُوَيْرِيَةَ رضي الله عنها : " أَنَّ النَّبِيَّ صَلَّى اللهُ عَلَيْهِ وَسَلَّمَ خَرَجَ مِنْ عِنْدِهَا بُكْرَةً حِينَ صَلَّى الصُّبْحَ ، وَهِيَ فِي مَسْجِدِهَا، ثُمَّ رَجَعَ بَعْدَ أَنْ أَضْحَى ، وَهِيَ جَالِسَةٌ ، فَقَالَ: (مَا زِلْتِ عَلَى الْحَالِ الَّتِي فَارَقْتُكِ عَلَيْهَا؟) قَالَتْ: نَعَمْ ، قَالَ النَّبِيُّ صَلَّى اللهُ عَلَيْهِ وَسَلَّمَ: ( لَقَدْ قُلْتُ بَعْدَكِ أَرْبَعَ كَلِمَاتٍ ، ثَلَاثَ مَرَّاتٍ ، لَوْ وُزِنَتْ بِمَا قُلْتِ مُنْذُ الْيَوْمِ لَوَزَنَتْهُنَّ: سُبْحَانَ اللهِ وَبِحَمْدِهِ، عَدَدَ خَلْقِهِ وَرِضَا نَفْسِهِ وَزِنَةَ عَرْشِهِ وَمِدَادَ كَلِمَاتِهِ ) .
قال القاري رحمه الله :
" ( لَوَزَنَتْهُنَّ) أَيْ : لَتَرَجَّحَتْ تِلْكَ الْكَلِمَاتُ عَلَى جَمِيعِ أَذْكَارِكِ ، وَزَادَتْ عَلَيْهِنَّ فِي الْأَجْرِ وَالثَّوَابِ ، أَوْ لَسَاوَتْهُنَّ، أَيْ: سَاوَتْهُنَّ ، أَوْ غَلَبَتْهُنَّ، وَفِيهِ تَنْبِيهٌ عَلَى أَنَّهَا كَلِمَاتٌ كَثِيرَةُ الْمَعْنَى ؛ لَوْ قُوبِلَتْ بِمَا قُلْتِ لَسَاوَتْهُنَّ "`,
  },
  // this is 3
  Primitiveness: {
    text: `(اللَّهُمَّ صَلِّ وَسَلِّمْ وَبَارِكْ على نَبِيِّنَا مُحمَّد، فقد جاء في الحديث: مَن صلى عَلَيَّ حين يُصْبِحُ عَشْرًا، وحين يُمْسِي عَشْرًا، أَدْرَكَتْه شفاعتي يومَ القيامةِ)`,
    count: 1,
    Details: `جاء عن عبدالله بن عبدالرحمن بن أبزى، عن أبيه -رضي الله عنهما- قال: كان النبيُّ ﷺ إذا أصبح قال: أصبحنا على فطرة الإسلام، وكلمة الإخلاص، ودين نبينا محمدٍ ﷺ، وملّة أبينا إبراهيم حنيفًا مسلمًا، وفي روايةٍ: وعلى دين نبينا محمدٍ، وعلى ملَّة أبينا، وفي آخره: وما كان من المشركين، وفي روايةٍ: أصبحنا على الفطرة والإخلاص، ودين نبينا محمدٍ، وملَّة أبينا إبراهيم حنيفًا مسلمًا، وما أنا من المشركين`,
  },
  pardon: {
    text: `(لا إلهَ إلَّا اللهُ وحدَه لا شريكَ له له الملكُ وله الحمدُ وهو على كلِّ شيءٍ قديرٌ)`,
    count: 1,
    Details: `جاء عن عبدالله بن عمر  أنَّه قال: لم يكن رسولُ الله ﷺ يدع هؤلاء الدَّعوات حين يُمسي وحين يُصبح: اللهم إني أسألك العافيةَ في الدنيا والآخرة، اللهم إني أسألك العفو والعافية في ديني ودُنياي وأهلي ومالي، اللهم استر عوراتي، وآمن روعاتي، اللهم احفظني من بين يدي، ومن خلفي، وعن يميني، وعن شمالي، ومن فوقي، وأعوذ بعظمتك أن أُغتال من تحتي`,
  },
  HeHasNoPartner: {
    text: `
(أمسَيْنا على فِطرةِ الإسلامِ وعلى كَلِمةِ الإخلاصِ وعلى دينِ نبيِّنا محمَّدٍ صلَّى اللهُ عليه وسلَّم وعلى مِلَّةِ أبينا إبراهيمَ حنيفًا مسلمًا وما كان مِنَ المشركينَ)`,
    count: 1,
    Details: `جاء من حديث أبي ذرٍّ: أنَّ رسولَ الله ﷺ قال: مَن قال في دُبر صلاة الفجر وهو ثانٍ رجليه، قبل أن يتكلم: لا إله إلا الله وحده لا شريكَ له، له الملك، وله الحمد، يُحيي ويُميت، وهو على كل شيءٍ قدير. عشر مرات؛ كُتِبَ له عشر حسناتٍ، ومُحِيَ عنه عشر سيئاتٍ، ورُفِعَ له عشر درجاتٍ، وكان يومه ذلك كلّه في حرزٍ من كل مكروهٍ، وحُرِسَ من الشَّيطان، ولم ينبغِ لذنبٍ أن يُدركه في ذلك اليوم، إلا الشِّرك بالله. هذا الحديث أخرجه الترمذي، وقال عنه: حسنٌ، غريبٌ، صحيحٌ`,
  },
  // this is 4 => 5 zekr
  HisName: {
    text: `(اللَّهمَّ ما أصبح بي مِن نعمةٍ أو بأحَدٍ مِن خَلْقِكَ، فمنكَ وحدَكَ لا شريكَ لكَ، فلَكَ الحمدُ ولكَ الشُّكرُ)`,
    count: 1,
    Details: `عن عثمان بن عفان رضي الله عنه قال: قال النبي عليه الصلاة والسلام: (ما من عبد يقول في صباح كل يوم ومساء كل ليلة: باسم الله الذي لا يضر مع اسمه شيء في الأرض ولا في السماء وهو السميع العليم، ثلاث مرات لم يضره شيء)

وقال: (ما نزل أحدكم منزلاً -أي: يخشى منه- فيقول: باسم الله الذي لا يضر مع اسمه شيء في الأرض ولا في السماء وهو السميع العليم ثلاث مرات لم يضره شيء حتى يخرج) أي: حتى يخرج من هذا الذي يخافه، فلم يضره شيء حتى يصبح أو حتى يمسي`,
  },
  // اول الادعية
  AskForgiveness: {
    text: `(اللَّهمَّ عافِني في بدَني اللَّهمَّ عافِني في سمعي اللَّهمَّ عافِني في بصري لا إلهَ إلَّا أنت، اللَّهمَّ إنِّي أعوذُ بِكَ منَ الكُفْرِ والفقرِ اللَّهمَّ إنِّي أعوذُ بكَ من عذابِ القبرِ لا إلهَ إلَّا أنت)`,
    count: 3,
    Details: `حديث صحيح رواه البخاري في صحيحه من حديث شداد بن أوس، يقول -عليه الصلاة والسلام-: سيد الاستغفار أن تقول: اللهم أنت ربي لا إله إلا أنت، خلقتني وأنا عبدك ... إلى آخره، فهو حديث صحيح`,
  },
  GlorybetoHim: {
    text: `(اللهم إنا نعوذُ بك من أن نُشرِكَ بك شيئًا نعلَمُه، و نستغفرُك لما لا نعلمُه)`,
    count: 1,
    Details: `عن النبي صَلَّى اللَّهُ عَلَيْهِ وَسَلَّمَ أنه قال : ( مَنْ قَالَ حِينَ يُصْبِحُ وَحِينَ يُمْسِي : سُبْحَانَ اللَّهِ وَبِحَمْدِهِ مِائَةَ مَرَّةٍ ، لَمْ يَأْتِ أَحَدٌ يَوْمَ الْقِيَامَةِ بِأَفْضَلَ مِمَّا جَاءَ بِهِ إِلَّا أَحَدٌ قَالَ مِثْلَ مَا قَالَ أَوْ زَادَ عَلَيْهِ ) أخرجه مسلم (2692)`,
  },
  charm: {
    text: `أستغفرُ اللهَ العظيمَ الذي لا إلهَ إلَّا هو الحيَّ القيومَ وأتوبُ إليه`,
    count: 1,
    Details: `من قالَ حين يصبحُ أعوذُ بكلماتِ الله التاماتِ من شرِّ ما خلقَ ثلاثَ مراتٍ لم تضرهُ عقربٌ حتى يمسِي ، ومن قالها حينَ يمسي لم تضرُّه حتى يصبحَ
الراوي : أبو هريرة | المحدث : ابن حجر العسقلاني | المصدر : نتائج الأفكار | الصفحة أو الرقم : 2/360 | خلاصة حكم المحدث : له أصل | التخريج : أخرجه مسلم (2709) بنحوه`,
  },
  Wehavebecome: {
    text: `اللَّهمَّ إنِّي أسألُكَ عِلمًا نافعًا ورزقًا طيِّبًا وعملًا متقبَّلً`,
    count: 1,
    Details: `جاء من أذكار المساء والصباح: ما رواه الإمامُ مسلم -رحمه الله- في "صحيحه" من حديث عبدالله بن مسعودٍ  قال: "كان نبيُّ الله ﷺ إذا أمسى قال: أمسينا وأمسى الملكُ لله، والحمد لله، لا إله إلا الله وحده لا شريكَ له، له الملك، وله الحمد، وهو على كل شيءٍ قدير، ربِّ أسألك خيرَ ما في هذه الليلة، وخيرَ ما بعدها، وأعوذ بك من شرِّ ما في هذه الليلة، وشرِّ ما بعدها، ربِّ أعوذ بك من الكسل، وسُوء الكِبَر، ربِّ أعوذ بك من عذابٍ في النار، وعذابٍ في القبر، وإذا أصبح قال أيضًا: أصبحنا وأصبح الملك لله ...، إلى آخره`,
  },
};

function EveningCount() {
  // this is 1
  const [count1, setCount1] = useState(evningAzkar.hold.count);
  const [count2, setCount2] = useState(evningAzkar.Falaq.count);
  const [count3, setCount3] = useState(evningAzkar.people.count);

  // this is 2
  const [count4, setCount4] = useState(evningAzkar.become.count);
  const [count5, setCount5] = useState(evningAzkar.unseen.count);
  const [count6, setCount6] = useState(evningAzkar.Glory.count);

  // this is 3
  const [count7, setCount7] = useState(evningAzkar.Primitiveness.count);
  const [count8, setCount8] = useState(evningAzkar.pardon.count);
  const [count9, setCount9] = useState(evningAzkar.HeHasNoPartner.count);

  // last 5 states
  const [count10, setCount10] = useState(evningAzkar.HisName.count);
  const [count11, setCount11] = useState(evningAzkar.AskForgiveness.count);
  const [count12, setCount12] = useState(evningAzkar.GlorybetoHim.count);
  const [count13, setCount13] = useState(evningAzkar.charm.count);
  const [count14, setCount14] = useState(evningAzkar.Wehavebecome.count);

  const [countDone, setCountDone] = useState(false);

  let navigate = useNavigate();

  const done1 = () => {
    count1 > 0 && setCount1(count1 - 1);
  };

  const done2 = () => {
    count2 > 0 && setCount2(count2 - 1);
    // if (!countDone) {
    //   if (count2 === 1) {
    //     setCountDone(true);
    //     toast.success("🦄 Wow so easy!", {
    //       position: "top-right",
    //       autoClose: 5000,
    //       hideProgressBar: false,
    //       closeOnClick: true,
    //       pauseOnHover: true,
    //       draggable: true,
    //       progress: undefined,
    //       theme: "light",
    //     });
    //   }
    // }
  };

  const done3 = () => {
    count3 > 0 && setCount3(count3 - 1);
    // if (!countDone) {
    //   if (count3 === 1) {
    //     setCountDone(true);
    //     toast.success("🦄 Wow so easy!", {
    //       position: "top-right",
    //       autoClose: 5000,
    //       hideProgressBar: false,
    //       closeOnClick: true,
    //       pauseOnHover: true,
    //       draggable: true,
    //       progress: undefined,
    //       theme: "light",
    //     });
    //   }
    // }
  };

  const done4 = () => {
    count4 > 0 && setCount4(count4 - 1);
    // if (!countDone) {
    //   if (count3 === 1) {
    //     setCountDone(true);
    //     toast.success("🦄 Wow so easy!", {
    //       position: "top-right",
    //       autoClose: 5000,
    //       hideProgressBar: false,
    //       closeOnClick: true,
    //       pauseOnHover: true,
    //       draggable: true,
    //       progress: undefined,
    //       theme: "light",
    //     });
    //   }
    // }
  };

  const done5 = () => {
    count5 > 0 && setCount5(count5 - 1);
    // if (!countDone) {
    //   if (count3 === 1) {
    //     setCountDone(true);
    //     toast.success("🦄 Wow so easy!", {
    //       position: "top-right",
    //       autoClose: 5000,
    //       hideProgressBar: false,
    //       closeOnClick: true,
    //       pauseOnHover: true,
    //       draggable: true,
    //       progress: undefined,
    //       theme: "light",
    //     });
    //   }
    // }
  };

  const done6 = () => {
    count6 > 0 && setCount6(count6 - 1);
    // if (!countDone) {
    //   if (count3 === 1) {
    //     setCountDone(true);
    //     toast.success("🦄 Wow so easy!", {
    //       position: "top-right",
    //       autoClose: 5000,
    //       hideProgressBar: false,
    //       closeOnClick: true,
    //       pauseOnHover: true,
    //       draggable: true,
    //       progress: undefined,
    //       theme: "light",
    //     });
    //   }
    // }
  };

  const done7 = () => {
    count7 > 0 && setCount7(count7 - 1);
    // if (!countDone) {
    //   if (count3 === 1) {
    //     setCountDone(true);
    //     toast.success("🦄 Wow so easy!", {
    //       position: "top-right",
    //       autoClose: 5000,
    //       hideProgressBar: false,
    //       closeOnClick: true,
    //       pauseOnHover: true,
    //       draggable: true,
    //       progress: undefined,
    //       theme: "light",
    //     });
    //   }
    // }
  };

  const done8 = () => {
    count8 > 0 && setCount8(count8 - 1);
    // if (!countDone) {
    //   if (count3 === 1) {
    //     setCountDone(true);
    //     toast.success("🦄 Wow so easy!", {
    //       position: "top-right",
    //       autoClose: 5000,
    //       hideProgressBar: false,
    //       closeOnClick: true,
    //       pauseOnHover: true,
    //       draggable: true,
    //       progress: undefined,
    //       theme: "light",
    //     });
    //   }
    // }
  };

  const done9 = () => {
    count9 > 0 && setCount9(count9 - 1);
    // if (!countDone) {
    //   if (count3 === 1) {
    //     setCountDone(true);
    //     toast.success("🦄 Wow so easy!", {
    //       position: "top-right",
    //       autoClose: 5000,
    //       hideProgressBar: false,
    //       closeOnClick: true,
    //       pauseOnHover: true,
    //       draggable: true,
    //       progress: undefined,
    //       theme: "light",
    //     });
    //   }
    // }
  };

  // Last 5 zekr
  const done10 = () => {
    count10 > 0 && setCount10(count10 - 1);
    // if (!countDone) {
    //   if (count3 === 1) {
    //     setCountDone(true);
    //     toast.success("🦄 Wow so easy!", {
    //       position: "top-right",
    //       autoClose: 5000,
    //       hideProgressBar: false,
    //       closeOnClick: true,
    //       pauseOnHover: true,
    //       draggable: true,
    //       progress: undefined,
    //       theme: "light",
    //     });
    //   }
    // }
  };

  const done11 = () => {
    count11 > 0 && setCount11(count11 - 1);
    // if (!countDone) {
    //   if (count3 === 1) {
    //     setCountDone(true);
    //     toast.success("🦄 Wow so easy!", {
    //       position: "top-right",
    //       autoClose: 5000,
    //       hideProgressBar: false,
    //       closeOnClick: true,
    //       pauseOnHover: true,
    //       draggable: true,
    //       progress: undefined,
    //       theme: "light",
    //     });
    //   }
    // }
  };

  const done12 = () => {
    count12 > 0 && setCount12(count12 - 1);
    // if (!countDone) {
    //   if (count3 === 1) {
    //     setCountDone(true);
    //     toast.success("🦄 Wow so easy!", {
    //       position: "top-right",
    //       autoClose: 5000,
    //       hideProgressBar: false,
    //       closeOnClick: true,
    //       pauseOnHover: true,
    //       draggable: true,
    //       progress: undefined,
    //       theme: "light",
    //     });
    //   }
    // }
  };

  const done13 = () => {
    count13 > 0 && setCount13(count13 - 1);
    // if (!countDone) {
    //   if (count3 === 1) {
    //     setCountDone(true);
    //     toast.success("🦄 Wow so easy!", {
    //       position: "top-right",
    //       autoClose: 5000,
    //       hideProgressBar: false,
    //       closeOnClick: true,
    //       pauseOnHover: true,
    //       draggable: true,
    //       progress: undefined,
    //       theme: "light",
    //     });
    //   }
    // }
  };

  const done14 = () => {
    count14 > 0 && setCount14(count14 - 1);
    if (!countDone) {
      if (count14 === 1) {
        setCountDone(true);
        toast.success(
          "لقد اتممت اذكار المساء , فتح الله عليك و تقبل منك صالح الاعمال♥",
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          }
        );
        navigate("/");
      }
    }
  };

  // Chack Text
  const azkarNow = () => {
    if (count1 >= 1) {
      return evningAzkar.hold.text;
    } else if (count1 <= 1 && count2 >= 1) {
      return evningAzkar.Falaq.text;
    } else if (count2 <= 1 && count3 >= 1) {
      return evningAzkar.people.text;
    } else if (count3 <= 1 && count4 >= 1) {
      return evningAzkar.become.text;
    } else if (count4 <= 1 && count5 >= 1) {
      return evningAzkar.unseen.text;
    } else if (count5 <= 1 && count6 >= 1) {
      return evningAzkar.Glory.text;
    } else if (count6 <= 1 && count7 >= 1) {
      return evningAzkar.Primitiveness.text;
    } else if (count7 <= 1 && count8 >= 1) {
      return evningAzkar.pardon.text;
    } else if (count8 <= 1 && count9 >= 1) {
      return evningAzkar.HeHasNoPartner.text; // this is line
    } else if (count9 <= 1 && count10 >= 1) {
      return evningAzkar.HisName.text;
    } else if (count10 <= 1 && count11 >= 1) {
      return evningAzkar.AskForgiveness.text;
    } else if (count11 <= 1 && count12 >= 1) {
      return evningAzkar.GlorybetoHim.text;
    } else if (count12 <= 1 && count13 >= 1) {
      return evningAzkar.charm.text;
    } else if (count13 <= 1 && count14 >= 1) {
      return evningAzkar.Wehavebecome.text;
    } else {
      return `لقد اتممت اذكار المساء لا تنسي اذكار الصباح ♥♥♥`;
    }
  };

  // Chack Text
  const DetailsAzkarNow = () => {
    if (count1 >= 1) {
      return evningAzkar.hold.Details;
    } else if (count1 <= 1 && count2 >= 1) {
      return evningAzkar.Falaq.Details;
    } else if (count2 <= 1 && count3 >= 1) {
      return evningAzkar.people.Details;
    } else if (count3 <= 1 && count4 >= 1) {
      return evningAzkar.become.Details;
    } else if (count4 <= 1 && count5 >= 1) {
      return evningAzkar.unseen.Details;
    } else if (count5 <= 1 && count6 >= 1) {
      return evningAzkar.Glory.Details;
    } else if (count6 <= 1 && count7 >= 1) {
      return evningAzkar.Primitiveness.Details;
    } else if (count7 <= 1 && count8 >= 1) {
      return evningAzkar.pardon.Details;
    } else if (count8 <= 1 && count9 >= 1) {
      return evningAzkar.HeHasNoPartner.Details; // this is line
    } else if (count9 <= 1 && count10 >= 1) {
      return evningAzkar.HisName.Details;
    } else if (count10 <= 1 && count11 >= 1) {
      return evningAzkar.AskForgiveness.Details;
    } else if (count11 <= 1 && count12 >= 1) {
      return evningAzkar.GlorybetoHim.Details;
    } else if (count12 <= 1 && count13 >= 1) {
      return evningAzkar.charm.Details;
    } else if (count13 <= 1 && count14 >= 1) {
      return evningAzkar.Wehavebecome.Details;
    } else {
      return `لقد اتممت اذكار المساء لا تنسي اذكار الصباح ♥♥♥`;
    }
  };

  // Chack Action
  const actionNow = () => {
    if (count1 >= 1) {
      return (
        <div
          className={`col-md-4  col-lg-3  flex justify-center `}
          onClick={done1}
        >
          <button
            className={`text-center w-fit h-fit p-4 z-50 ${styles.clickAzkar}`}
          >
            <h6 className="text-nowrap">انقر هنا</h6>
            <div className="text-nowrap">
              {count1 >= 0 && `${evningAzkar.hold.count} / ${count1}`}
            </div>
          </button>
        </div>
      );
    } else if (count1 <= 1 && count2 >= 1) {
      return (
        <div
          className={`col-md-4  col-lg-3  flex justify-center `}
          onClick={done2}
        >
          <button
            className={`text-center w-fit h-fit p-4 z-50 ${styles.clickAzkar}`}
          >
            <h6 className="text-nowrap">انقر هنا</h6>
            <div className="text-nowrap">
              {count2 >= 0 && `${evningAzkar.Falaq.count} / ${count2}`}
            </div>
          </button>
        </div>
      );
    } else if (count2 <= 1 && count3 >= 1) {
      return (
        <div
          className={`col-md-4  col-lg-3  flex justify-center `}
          onClick={done3}
        >
          <button
            className={`text-center w-fit h-fit p-4 z-50 ${styles.clickAzkar}`}
          >
            <h6 className="text-nowrap">انقر هنا</h6>
            <div className="text-nowrap">
              {count3 >= 0 && `${evningAzkar.people.count} / ${count3}`}
            </div>
          </button>
        </div>
      );
    } else if (count3 <= 1 && count4 >= 1) {
      return (
        <div
          className={`col-md-4  col-lg-3  flex justify-center `}
          onClick={done4}
        >
          <button
            className={`text-center w-fit h-fit p-4 z-50 ${styles.clickAzkar}`}
          >
            <h6 className="text-nowrap">انقر هنا</h6>
            <div className="text-nowrap">
              {count4 >= 0 && `${evningAzkar.become.count} / ${count4}`}
            </div>
          </button>
        </div>
      );
    } else if (count4 <= 1 && count5 >= 1) {
      return (
        <div
          className={`col-md-4  col-lg-3  flex justify-center `}
          onClick={done5}
        >
          <button
            className={`text-center w-fit h-fit p-4 z-50 ${styles.clickAzkar}`}
          >
            <h6 className="text-nowrap">انقر هنا</h6>
            <div className="text-nowrap">
              {count5 >= 0 && `${evningAzkar.unseen.count} / ${count5}`}
            </div>
          </button>
        </div>
      );
    } else if (count5 <= 1 && count6 >= 1) {
      return (
        <div
          className={`col-md-4  col-lg-3  flex justify-center `}
          onClick={done6}
        >
          <button
            className={`text-center w-fit h-fit p-4 z-50 ${styles.clickAzkar}`}
          >
            <h6 className="text-nowrap">انقر هنا</h6>
            <div className="text-nowrap">
              {count6 >= 0 && `${evningAzkar.Glory.count} / ${count6}`}
            </div>
          </button>
        </div>
      );
    } else if (count6 <= 1 && count7 >= 1) {
      return (
        <div
          className={`col-md-4  col-lg-3  flex justify-center `}
          onClick={done7}
        >
          <button
            className={`text-center w-fit h-fit p-4 z-50 ${styles.clickAzkar}`}
          >
            <h6>انقر هنا</h6>
            <div>
              {count7 >= 0 && `${evningAzkar.Primitiveness.count} / ${count7}`}
            </div>
          </button>
        </div>
      );
    } else if (count7 <= 1 && count8 >= 1) {
      return (
        <div
          className={`col-md-4  col-lg-3  flex justify-center `}
          onClick={done8}
        >
          <button
            className={`text-center w-fit h-fit p-4 z-50 ${styles.clickAzkar}`}
          >
            <h6 className="text-nowrap">انقر هنا</h6>
            <div className="text-nowrap">
              {count8 >= 0 && `${evningAzkar.pardon.count} / ${count8}`}
            </div>
          </button>
        </div>
      );
    } else if (count8 <= 1 && count9 >= 1) {
      return (
        <div
          className={`col-md-4  col-lg-3  flex justify-center `}
          onClick={done9}
        >
          <button
            className={`text-center w-fit h-fit p-4 z-50 ${styles.clickAzkar}`}
          >
            <h6 className="text-nowrap">انقر هنا</h6>
            <div className="text-nowrap">
              {count9 >= 0 && `${evningAzkar.HeHasNoPartner.count} / ${count9}`}
            </div>
          </button>
        </div>
      );
    } else if (count9 <= 1 && count10 >= 1) {
      return (
        <div
          className={`col-md-4  col-lg-3  flex justify-center `}
          onClick={done10}
        >
          <button
            className={`text-center w-fit h-fit p-4 z-50 ${styles.clickAzkar}`}
          >
            <h6 className="text-nowrap">انقر هنا</h6>
            <div className="text-nowrap">
              {count10 >= 0 && `${evningAzkar.HisName.count} / ${count10}`}
            </div>
          </button>
        </div>
      );
    } else if (count10 <= 1 && count11 >= 1) {
      return (
        <div
          className={`col-md-4  col-lg-3  flex justify-center `}
          onClick={done11}
        >
          <button
            className={`text-center w-fit h-fit p-4 z-50 ${styles.clickAzkar}`}
          >
            <h6 className="text-nowrap">انقر هنا</h6>
            <div className="text-nowrap">
              {count11 >= 0 &&
                `${evningAzkar.AskForgiveness.count} / ${count11}`}
            </div>
          </button>
        </div>
      );
    } else if (count11 <= 1 && count12 >= 1) {
      return (
        <div
          className={`col-md-4  col-lg-3  flex justify-center `}
          onClick={done12}
        >
          <button
            className={`text-center w-fit h-fit p-4 z-50 ${styles.clickAzkar}`}
          >
            <h6 className="text-nowrap">انقر هنا</h6>
            <div className="text-nowrap">
              {count12 >= 0 && `${evningAzkar.GlorybetoHim.count} / ${count12}`}
            </div>
          </button>
        </div>
      );
    } else if (count12 <= 1 && count13 >= 1) {
      return (
        <div
          className={`col-md-4  col-lg-3  flex justify-center `}
          onClick={done13}
        >
          <button
            className={`text-center w-fit h-fit p-4 z-50 ${styles.clickAzkar}`}
          >
            <h6 className="text-nowrap">انقر هنا</h6>
            <div className="text-nowrap">
              {count13 >= 0 && `${evningAzkar.charm.count} / ${count13}`}
            </div>
          </button>
        </div>
      );
    } else if (count13 <= 1 && count14 >= 1) {
      return (
        <div
          className={`col-md-4  col-lg-3  flex justify-center `}
          onClick={done14}
        >
          <button
            className={`text-center w-fit h-fit p-4 z-50 ${styles.clickAzkar}`}
          >
            <h6 className="text-nowrap">انقر هنا</h6>
            <div className="text-nowrap">
              {count14 >= 0 && `${evningAzkar.Wehavebecome.count} / ${count14}`}
            </div>
          </button>
        </div>
      );
    } else {
      return null;
    }
  };
  return (
    <div className="relative ">
      {/*  */}
      <div className="flex justify-end mt-5 container">
        <div className="flex  z-40 justify-between mx-2 align-items-center row gap-4">
          <div className={`col-md-4 col-lg-8 px-2  py-2 ${styles.leftAzkar}`}>
            <h5 className="mb-0">{azkarNow()}</h5>
            <div className="text-start px-4">
              <PopoverPopupState text={DetailsAzkarNow()} />
            </div>
          </div>
          {actionNow()}
        </div>
      </div>
    </div>
  );
}

export default EveningCount;
